import { formatDateToYYYYMMDD, parseYYYMMDDToDate } from "../../../../utils/DateUtils";

// A vigência da bonificação é por mês. A API grava e devolve o dia 1 de cada mês
// ("2026-10-01"); a tela mostra só "10/2026".

/** Dia 1 do mês corrente, que é o mês padrão do filtro e do cadastro. */
export const currentMonth = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
};

/** Date do seletor de mês para o formato da API, sempre no dia 1. */
export const monthToApi = (date) => date
    ? formatDateToYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1))
    : null;

/** "2026-10-01" da API para o Date que o seletor de mês usa. */
export const monthFromApi = (value) => value ? parseYYYMMDDToDate(value) : null;

/** "2026-10-01" para "10/2026". */
export const monthLabel = (value) => {
    if (!value) {
        return '-';
    }
    const [year, month] = value.split('-');
    return `${month}/${year}`;
};

/**
 * Situação da bonificação em relação ao mês corrente: a começar, vigente ou encerrada. O
 * texto "AAAA-MM-DD" compara certo como texto, então não precisa virar Date.
 */
export const bonusSituation = (bonus, today = currentMonth()) => {
    const month = monthToApi(today);
    if (bonus.startMonth > month) {
        return 'upcoming';
    }
    if (bonus.endMonth && bonus.endMonth < month) {
        return 'ended';
    }
    return 'active';
};
